import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'kla-round-button',
  templateUrl: './round-button.component.html',
  styleUrls: ['./round-button.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class RoundButtonComponent implements OnInit {

  @Input()
  public title: string = "Button";

  @Input()
  public borderColor: string = "#ececec";

  @Input()
  public activeBorderColor: string = "#c6cfd6";

  @Input()
  public backgroundColor: string = "inherit";

  @Input()
  public color: string = "#a0a0a0";

  @Input()
  public activeColor: string = "#464646";

  @Input('activeButton')
  set setActiveButton(state: boolean){
    this.activeButton = state
    this.changeState(this.activeButton);
  }


  @Output()
  public onClick: EventEmitter<Event> = new EventEmitter<Event>();

  public style: any;

  public activeButton:boolean = false;
  constructor() { }

  ngOnInit() {
    this.changeState(this.activeButton)
  }

  clickOnButton(event: Event) {
    this.onClick.emit(event);
  }
  changeState(state: boolean){
    if(state){
      this.style = {
        'border-color': this.activeBorderColor,
        'color': this.activeColor,
        'background': this.backgroundColor
      };
    }else{
      this.style = {
      'border-color': this.borderColor,
      'color': this.color,
      'background': this.backgroundColor
    };
    }
  }
}
